module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image5c"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "353",
      "src": "images/15.jpg",
      "width": "300"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A home might be sweet, but it sure isn’t cheap. And they call it house “hunting” for a reason. This chapter includes a list of things you need to have in order to rent a place to live, plus some forms to make house/apartment hunting easier.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("Money you may have to have before you rent")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Application deposit (refunded when you sign the lease)")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Credit report fee (see chapter 8)")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• First month’s rent")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Security deposit (usually equals one month’s rent)")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Money for necessary items to set up house, such as trash cans, shower curtains, or window blinds")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• If a broker is involved, a fee may be required")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Deposit for utilities (including electricity, heating fuel, telephone, and cable)")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Money to furnish and stock apartment with necessities for living")])]), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Other things you’ll need")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Two references—two adults (not your buddies) who will vouch that you are a responsible, good person")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Checking account")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• A steady source of income")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("Apartment or rental house evaluation forms")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("When you visit one apartment after the next, they tend to blur together, and it’s easy to forget which one had what features. Download this online form at ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.simonsays.com",
      "target": "_blank"
    }
  }, [_vm._v("http://www.simonsays.com/content/book .cfm?tab=1&pid=614860&agid=38")]), _vm._v(", make copies and take them with you to take notes. Your notes will come in handy when trying to remember what you liked and didn’t like about each place.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("Complex "), _c('span', {
    staticClass: "txbfit"
  }, [_vm._v("_______________________________")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Address __________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Phone ____________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Web site ___________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Distance from work/school ____________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Distance from church _________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Distance from activities/social life ________________________")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Interior features:")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("How many square feet ____________________")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Space needed ______________ # of bedrooms: _______________")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("# of bathrooms: _______________ # of closets: _______________")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Check all that apply:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" shower")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" dishwasher")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" good water pressure")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" heat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" microwave")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" adequate lighting")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" cable")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" handicap accessible")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" pets allowed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" fire extinguishers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" pest control")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" bathtub")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" laundry hookups")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" air conditioning")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" refrigerator")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" window blinds")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" good cell-phone reception")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" Internet access")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" additional storage")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" smoke detectors")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" locks on doors")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" well-maintained/clean")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("List other pros: _____________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("__________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("List any cons: ______________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("___________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("Exterior features")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Check all that apply:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" laundry facility")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" parking lot")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" security system/doorman")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" safe neighborhood")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" near grocery store")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" fenced yard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" gym")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" good schools")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" manager lives on grounds")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" mailbox")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" garage")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" well-lighted exterior")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" near mass transit")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" yard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" pool")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" garbage removal/Dumpster")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" well-maintained/clean")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Is the apartment on the first floor? ___________________________")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("What is the noise level? ___________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Notes: ________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("______________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("______________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("______________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("______________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  })]), _c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "sidebartit"
  }, [_vm._v("Renting tips")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("• Rent should equal no more than 25 percent of your monthly income. If you earn $2,000/month, your rent should be $500 or less.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("• Ask the neighbors about noise levels, whether they’ve had any maintenance issues regarding the apartment/house, and how safe they feel in the neighborhood.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("• Visit on a weekend afternoon or weekday evening and observe people. Is this a community in which you can easily make connections?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("• Call the local police department and ask about the crime rate in the neighborhood and if any convicted sex offenders live nearby.")])]), _c('p', {
    staticClass: "indenthanging"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("• ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.familywatchdog.com",
      "target": "_blank"
    }
  }, [_vm._v("www.familywatchdog.us")]), _vm._v(" will also give you the names and addresses of convicted sex offenders.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f34b372","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch10.vue
// module id = 117
// module chunks = 0